import React, { Component } from 'react';
import './App.css';
import Todo from './todo/App'


class App extends Component {
  render() {
    return (
      <div className="App"> 
<Todo />
           </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js